<template>
    <div class="editor_panel-tab">
        <keep-alive>
            <component :is="activeTab" />
        </keep-alive>
    </div>
</template>

<script>
    import ImageTab from './TabContent/ImageTab.vue';
    import PhotoCellTab from './TabContent/PhotoCellTab.vue';
    import ShapeTab from './TabContent/ShapeTab.vue';
    import TextTab from './TabContent/TextTab.vue';
    import ThemeTab from './TabContent/ThemeTab.vue';
    import PlaceholderTab from './TabContent/PlaceholderTab.vue';

    export default {
        props: ['activeTab'],
        components: {
            ImageTab,
            PhotoCellTab,
            ShapeTab,
            TextTab,
            ThemeTab,
            PlaceholderTab
        } 
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .editor_panel-tab {
        background-color: var(--primary-color);
        color: $white;
        padding: $pd-s;
        overflow: hidden;
    }
    @media (max-width: 1200px) {
        .editor_panel-tab {
            padding: 10px;
        }
    }
</style>